var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{style:(_setup.styleProps)},[_c('v-card',{staticClass:"mt-8",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"justify-center",staticStyle:{"word-break":"break-word"}},[_vm._v(_vm._s(_setup.work_label))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }